export default "__VITE_PUBLIC_ASSET__67474475__"